export default __webpack_public_path__ + "static/media/EggProduction.8dd5c702.jpg";